import { QueryResult } from '@apollo/react-common';
import { useQuery } from '@apollo/react-hooks';

import { BasePageDataQuery } from '../../types/__generated__';
import { PageMetaContext } from '../context/PageMetaContext';
import basePage from '../server/basePage.gql';
import { useNotNullableContext } from './useNotNullableContext';

export default function useBasePageQuery(): QueryResult<BasePageDataQuery> {
  const { pageType, pageShortName, isPreview } = useNotNullableContext(
    PageMetaContext,
  );
  const result = useQuery<BasePageDataQuery>(basePage, {
    variables: {
      type: pageType.toUpperCase(),
      slug: pageShortName,
      preview: isPreview,
      includeEvent: pageType.toUpperCase() === 'FUNDRAISING',
    },
    ssr: true,
  });
  return result;
}
